export default __webpack_public_path__ + "static/project-slide-8-1640-765-6647eb8ccdaa91e571246e44ecf15507.jpg";